'use strict';

const _ = require('underscore');
const Mn = require('backbone.marionette');
const ReadMoreCollectionView = require('framework/ui/view/readmore-collection');
const IdeaQuery = require('feedback/domain/value/idea-query');
const IdeaCollectionRepository = require('feedback/domain/repository/idea-collection');
const IdeaStatCollection = require('feedback/domain/collection/idea-stats');
const AdminCoverView = require('feedback/ui/view/admin/common/cover');
const IdeaItemViewTemplate = require('feedback/ui/template/admin/idea/item.hbs');
const IdeaStateItemViewTemplate = require('feedback/ui/template/admin/idea/state.hbs');
const Template = require('feedback/ui/template/admin/idea/index.hbs');

const IdeaItemView = Mn.View.extend({
    tagName: 'li',
    className: 'list-item idea-item',
    template: IdeaItemViewTemplate,

    templateContext: function() {
        return {
            url: `/feedback/admin/ideas/${this.model.id}`,
            commentNum: this.model.getCommentCount(),
            stateColor: this.model.getState().color,
            isPrivate: !this.model.isPublic(),
            isUpdated: !_.isEqual(this.model.getCreatedAt(), this.model.getUpdatedAt())
        }
    }
});

const IdeaListView = ReadMoreCollectionView.extend({
    className: 'list',
    childView: IdeaItemView
});

const IdeaStateItemView = Mn.View.extend({
    tagName: 'span',
    template: IdeaStateItemViewTemplate,
    templateContext: function() {
        return {
            isSelected: this.getOption('query').isSelected(this.model.getName()),
            color: this.model.getState().color
        };
    }
});

const IdeaStateListView = Mn.CollectionView.extend({
    childView: IdeaStateItemView,
    childViewOptions: function() {
        return {
            query: this.getOption('query')
        };
    }
});

const IdeaAdminView = Mn.View.extend({
    tagName: 'div',
    template: Template,
    regions: {
        ideaList: '.idea-list',
        ideaStateList: '.idea-state-list',
        cover: '#cover',
    },

    onRender: function() {
        const urlParams = new URLSearchParams(location.search);
        const query = new IdeaQuery(urlParams.getAll('state'));
        const collection = IdeaCollectionRepository.adminIdeasByQuery(query);

        this.showChildView('cover', new AdminCoverView({isIdea: true}));

        collection
            .fetchFirstPage(30)
            .then(() => {
                this.showChildView('ideaList', new IdeaListView({
                    collection: collection
                }));
            });

        IdeaStatCollection.fetchOnce()
            .then(() => {
                this.showChildView('ideaStateList', new IdeaStateListView({
                    collection: IdeaStatCollection,
                    query: query
                }));

                $.material.init();
            })
    }
});

module.exports = IdeaAdminView;




// WEBPACK FOOTER //
// ./feedback/ui/view/admin/idea/index.js